import * as i0 from '@angular/core';
import { Directive, EventEmitter, Component, ChangeDetectionStrategy, ViewChild, Input, Output } from '@angular/core';
import { TuiNodeViewNg } from '@taiga-ui/editor/extensions/tiptap-node-view';
import { NgIf } from '@angular/common';
import { tuiIsNumber, tuiPx, TuiResizable, TuiResizer } from '@taiga-ui/cdk';
const _c0 = ["container"];
const _c1 = ["*"];
const _c2 = a0 => [a0, 0];
const _c3 = () => [1, 0];
const _c4 = () => [0, 1];
function TuiEditorResizable_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("tuiSizeChange", function TuiEditorResizable_div_4_Template_div_tuiSizeChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.sizeChange.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("tuiResizer", i0.ɵɵpureFunction0(1, _c4));
  }
}
let AbstractTuiEditorResizable = /*#__PURE__*/(() => {
  class AbstractTuiEditorResizable extends TuiNodeViewNg {
    constructor() {
      super(...arguments);
      this.currentHeight = 0;
      this.currentWidth = 0;
    }
    get node() {
      return this.localNode;
    }
    set node(value) {
      this.localNode = value;
      this.changeDetector.markForCheck();
    }
    get attrs() {
      return this.node?.attrs || {
        src: ''
      };
    }
    get width() {
      return (this.currentWidth || this.attrs.width) ?? null;
    }
    get height() {
      return (this.currentHeight || this.attrs.height) ?? null;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵAbstractTuiEditorResizable_BaseFactory;
        return function AbstractTuiEditorResizable_Factory(__ngFactoryType__) {
          return (ɵAbstractTuiEditorResizable_BaseFactory || (ɵAbstractTuiEditorResizable_BaseFactory = i0.ɵɵgetInheritedFactory(AbstractTuiEditorResizable)))(__ngFactoryType__ || AbstractTuiEditorResizable);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AbstractTuiEditorResizable,
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return AbstractTuiEditorResizable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiEditorResizable = /*#__PURE__*/(() => {
  class TuiEditorResizable {
    constructor() {
      this.autoHeight = false;
      this.width = null;
      this.height = null;
      this.sizeChange = new EventEmitter();
    }
    get hostWidth() {
      return tuiIsNumber(this.width) ? tuiPx(this.width) : this.width;
    }
    get hostHeight() {
      if (this.autoHeight) {
        return null;
      }
      return tuiIsNumber(this.height) ? tuiPx(this.height) : this.height;
    }
    static {
      this.ɵfac = function TuiEditorResizable_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiEditorResizable)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiEditorResizable,
        selectors: [["tui-editor-resizable"]],
        viewQuery: function TuiEditorResizable_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function TuiEditorResizable_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.hostWidth)("height", ctx.hostHeight);
          }
        },
        inputs: {
          autoHeight: "autoHeight",
          width: "width",
          height: "height"
        },
        outputs: {
          sizeChange: "sizeChange"
        },
        ngContentSelectors: _c1,
        decls: 6,
        vars: 8,
        consts: [["container", ""], ["tuiResizable", "", 1, "t-resizable"], [1, "t-handle", "t-handle-left-side", 3, "tuiSizeChange", "tuiResizer"], ["class", "t-handle t-handle-bottom-side", 3, "tuiResizer", "tuiSizeChange", 4, "ngIf"], [1, "t-handle", "t-handle-right-side", 3, "tuiSizeChange", "tuiResizer"], [1, "t-handle", "t-handle-bottom-side", 3, "tuiSizeChange", "tuiResizer"]],
        template: function TuiEditorResizable_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵlistener("tuiSizeChange", function TuiEditorResizable_Template_div_tuiSizeChange_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.sizeChange.emit($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, TuiEditorResizable_div_4_Template, 1, 2, "div", 3);
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵlistener("tuiSizeChange", function TuiEditorResizable_Template_div_tuiSizeChange_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.sizeChange.emit($event));
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("t-resizable-auto-height", ctx.autoHeight);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("tuiResizer", i0.ɵɵpureFunction1(5, _c2, -1));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.autoHeight);
            i0.ɵɵadvance();
            i0.ɵɵproperty("tuiResizer", i0.ɵɵpureFunction0(7, _c3));
          }
        },
        dependencies: [NgIf, TuiResizable, TuiResizer],
        styles: ["[_nghost-%COMP%]{position:relative;display:inline-block;box-sizing:border-box}[_nghost-%COMP%]   .t-resizable[_ngcontent-%COMP%]{box-sizing:border-box}[_nghost-%COMP%]   .t-resizable-auto-height[_ngcontent-%COMP%]{block-size:auto!important}[_nghost-%COMP%]   iframe[_ngcontent-%COMP%]{display:inline;pointer-events:none}[_nghost-%COMP%]:hover   .t-handle[_ngcontent-%COMP%]:after{opacity:1}.t-handle[_ngcontent-%COMP%]{position:absolute;top:0;display:flex;inline-size:.75rem;cursor:col-resize;justify-content:center;align-items:center;block-size:100%}.t-handle[_ngcontent-%COMP%]:after{transition-property:opacity;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;content:\"\";inline-size:50%;block-size:33%;box-sizing:border-box;border-radius:var(--tui-radius-m);background:var(--tui-background-accent-opposite-hover);border:.0625rem solid var(--tui-background-neutral-1-hover);opacity:0}.t-handle-left-side[_ngcontent-%COMP%]{left:0}.t-handle-bottom-side[_ngcontent-%COMP%]{top:unset;bottom:.3125rem;block-size:.95rem;inline-size:100%}.t-handle-right-side[_ngcontent-%COMP%]{right:0}"],
        changeDetection: 0
      });
    }
  }
  return TuiEditorResizable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractTuiEditorResizable, TuiEditorResizable };
